import { render } from "./SearchView.vue?vue&type=template&id=040a3df9&ts=true"
import script from "./SearchView.vue?vue&type=script&lang=ts"
export * from "./SearchView.vue?vue&type=script&lang=ts"

import "./SearchView.vue?vue&type=style&index=0&id=040a3df9&lang=scss"

import exportComponent from "/Users/rboss/repos/TRENZ/Kunden/KaRa/Mockup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__